<template>
  <a-modal
    :visible="visible"
    width="702px"
    :mask-closable="false"
    :title="title"
    :confirm-loading="btnIsLoading"
    @ok="$emit('handleSubmit')"
    @cancel="$emit('onCancel')"
  >
    <basic-form
      ref="basicForm"
      :form-data="formData"
    >
      <template #name>
        <a-input
          v-decorator="[
            'name',
            {
              rules: [
                {
                  required: true,
                  message: '请输入职称',
                },
              ],
            },
          ]"
          placeholder="请输入职称"
        />
      </template>
    </basic-form>
  </a-modal>
</template>
<script>
import { formData } from '../data/index';
export default {
  props: ['visible', 'title', 'btnIsLoading'],
  data() {
    return {
      formData,
    };
  },
  async mounted() {
  },
};
</script>
<style lang="scss" scoped>
.client-modal-wrapper {
}
</style>
